import pick from 'lodash/pick';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import setDisplayName from 'recompose/setDisplayName';
import ImageEditForm from 'components/images/ImageEditForm';
import imageEditConfig from 'components/images/imageFormConfig';
import {makeFormValidator} from 'utils/forms';
import {
  changeImageSelectionAction,
  showImageEditFormErrorsAction,
  updatePendingImageUploadAction
} from 'pages/Images/actions';

const validateForm = makeFormValidator(imageEditConfig);

const mapStateToProps = state => {
  const {showImageEditFormErrors, imageEditFormErrors} = state.images;

  return {
    showErrors: showImageEditFormErrors,
    errors: imageEditFormErrors,
  };
};

const mapDispatchToProps = dispatch => {
  // bindActionCreators doesn't like nested objects, so react-slick callbacks get bound here.
  const carouselSettings = {
    beforeChange: (prevIndex, nextIndex) => dispatch(changeImageSelectionAction(nextIndex))
  };

  return {
    carouselSettings,
    ...bindActionCreators({
      onValueChanged: (resourcePath, fieldPath, value) => updatePendingImageUploadAction(fieldPath.join(''), value),
      onInvalidForm: showImageEditFormErrorsAction
    }, dispatch)
  };
};

export default compose(
  setDisplayName('ImageInfoValidator'),
  connect(mapStateToProps, mapDispatchToProps),
  withProps(props => ({
    onSaveData: data => {
      // intercept form data on submit and validate.
      const errors = validateForm(data);

      if (Object.keys(errors).length > 0) {
        props.onInvalidForm(errors);
      } else {
        // remove unnecessary fields for the API.
        props.onSaveData(pick(data, ['name', 'filename', 'source', 'altAttribute', 'link', 'id']));
      }
    }
  }))
);



// WEBPACK FOOTER //
// ./public/hoc/imageInfoValidator.js